import React, { useState } from 'react';
import PropTypes from 'prop-types';
import s from './PointsTableWrapperV2.scss';

const PointsTableWrapperV2 = props => {
  const { items = {} } = props.sectionItem || {};

  const getFutureEvents = eventsList => {
    const today = new Date();

    today.setHours(0, 0, 0, 0);

    const futureEvents = eventsList.filter(event => {
      const eventDateParts = event.date.split('/');
      const eventDate = new Date(
        `${eventDateParts[2]}-${eventDateParts[1]}-${eventDateParts[0]}`,
      );
      // Set time to 00:00:00 to compare only dates
      eventDate.setHours(0, 0, 0, 0);

      return eventDate >= today;
    });

    return futureEvents;
  };

  function filterEventsByDate(date) {
    const filteredEvents = [];

    if (date === 'all') {
      return getFutureEvents(items.calendar).length > 0
        ? getFutureEvents(items.calendar)
        : items.calendar;
    }
    items.calendar.forEach(day => {
      if (day.date === date) {
        filteredEvents.push(day);
      }
    });

    return filteredEvents;
  }

  // function formatDateCalender(date) {
  //   // Ensure that the input is a valid Date object
  //   if (!(date instanceof Date) || isNaN(date.getTime())) {
  //     throw new Error('Invalid date');
  //   }

  //   // Get the month, day, and year from the Date object
  //   const month = `0${date.getMonth() + 1}`.slice(-2);
  //   const day = `0${date.getDate()}`.slice(-2);
  //   const year = date.getFullYear();

  //   // Return the formatted date string
  //   return `${day}/${month}/${year}`;
  // }

  const [selectedDate, setSelectedDate] = useState('all');
  const [sceduleData, setSceduleDataData] = useState(filterEventsByDate('all'));

  const [timeFormat, setTimeFormat] = useState('IST');

  // const toggleTimeFormat = () => {
  //   setTimeFormat(timeFormat === 'IST' ? 'GMT' : 'IST');
  // };

  const handleTimeFormatChange = event => {
    setTimeFormat(event.target.value);
  };

  const groupBySport = data =>
    data.reduce((acc, event) => {
      if (!acc[event.sport]) {
        acc[event.sport] = [];
      }
      acc[event.sport].push(event);
      return acc;
    }, {});

  const convertTo12HourFormat = time => {
    const [hours, minutes] = time.split(':');
    const hoursInt = parseInt(hours, 10);
    const suffix = hoursInt >= 12 ? 'PM' : 'AM';
    const adjustedHours = hoursInt % 12 || 12; // Adjusts "0" to "12" for midnight
    return `${adjustedHours}:${minutes} ${suffix}`;
  };

  const ScheduleCard = ({ event }) => (
    <div className={s.event}>
      <div className={s.teamTime}>
        <div className={s.time}>
          <span>Starting at</span>{' '}
          <strong>
            {timeFormat === 'IST'
              ? convertTo12HourFormat(`${event.start_time_ist}`)
              : convertTo12HourFormat(`${event.start_time}`)}
          </strong>
        </div>

        <div
          className={`${s.playerInfo} ${
            event.opponent_team_short_name || event.opponent_team_name
              ? s.opponentInfo
              : ''
          }`}
        >
          {event.team_short_name && (
            <div className={s.countryName}>
              <div className={s.country}>
                <i className={`${s.flag} ${s[event.team_short_name]}`} />
              </div>
              <span>{event.team_short_name}</span>
            </div>
          )}
          {(event.opponent_team_short_name || event.opponent_team_name) && (
            <>
              <div className={s.vsLogo}>
                <i className={s.vsIcon} />
              </div>
              {event.opponent_team_short_name && (
                <div className={s.countryName}>
                  <div className={s.country}>
                    <i
                      className={`${s.flag} ${
                        s[event.opponent_team_short_name]
                      }`}
                    />
                  </div>
                  <span>{event.opponent_team_short_name}</span>
                </div>
              )}
              {!event.opponent_team_short_name &&
                event.opponent_team_name && (
                  <div className={s.countryName}>
                    <span>{event.opponent_team_name}</span>
                  </div>
                )}
            </>
          )}
          {!(event.opponent_team_short_name || event.opponent_team_name) && (
            <div className={s.player}>
              {event.player &&
                event.player.map((player, index) => (
                  <span key={index}>{player}</span>
                ))}
            </div>
          )}
        </div>
      </div>

      {event.opponent_player &&
        event.opponent_player.length > 0 && (
          <div className={s.playersname}>
            <div className={s.eventInfo}>
              <div className={s.playersWrap}>
                <strong>{event.team_name} :</strong>
                <div className={s.players}>
                  {event.player &&
                    event.player.map((player, index) => (
                      <span key={index}>{player}</span>
                    ))}
                </div>
              </div>
            </div>
            <div className={s.eventInfo}>
              <div className={s.playersWrap}>
                <strong>{event.opponent_team_name} :</strong>
                <div className={s.players}>
                  {event.opponent_player &&
                    event.opponent_player.map((opponent_player, index) => (
                      <span key={index}>{opponent_player}</span>
                    ))}
                </div>
              </div>
            </div>
          </div>
        )}
      <div className={s.eventInfo}>
        {event.is_medal_event && <i className={s.medalIcon} />}{' '}
        <span>{event.event_display_name}</span>
      </div>
    </div>
  );

  const formatDate = dateString => {
    const [day, month] = dateString.split('/');
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    return `${day} ${months[parseInt(month, 10) - 1]}`;
  };

  const formatDateevent = dateString => {
    const [day, month, year] = dateString.split('/');
    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    return `${day} ${months[parseInt(month, 10) - 1]} ${year}`;
  };

  const dropdownDateChange = event => {
    setSelectedDate(event.target.value);
    const filteredEvents = filterEventsByDate(event.target.value);
    setSceduleDataData(filteredEvents);
  };

  const groupDataList = items;
  const scheduleDataList = sceduleData || groupDataList?.calendar;

  return (
    <>
      <div className={`${s.TopBannerWrap} base_shimmer`}>
        <div className={`${s.TopBanner}`}>
          <picture>
            <source
              media="(min-width:1000px)"
              srcSet="https://static.toiimg.com/photo/111577719.cms"
            />
            <img
              src="https://static.toiimg.com/photo/111955848.cms"
              alt="banner-img"
            />
          </picture>
          <div className={s.bannerText}>
            <h1 className={s.headText}>
              <span className={s.logoHead}>
                <img
                  src="https://static.toiimg.com/photo/112101819.cms"
                  alt="paris 2024"
                />{' '}
                Paris 2024 Olympics
              </span>
              <span className={s.heading}>Schedule for Team India</span>
            </h1>
            <div className={s.logo}>
              <div className={s.logoHead}>
                <img
                  src="https://static.toiimg.com/photo/111580093.jpg"
                  alt="logo"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={s.schedulePage}>
        {/* <button onClick={toggleTimeFormat}>
          Toggle to {timeFormat === 'IST' ? 'GMT' : 'IST'}
        </button> */}

        {groupDataList &&
          groupDataList?.calendar &&
          Array.isArray(groupDataList?.calendar) &&
          groupDataList?.calendar.length > 0 && (
            <>
              <div className={s.dateWrap}>
                <div className={s.date}>
                  <i className={s.calendarIcon} />
                  <select
                    id="date-select"
                    value={selectedDate}
                    onChange={dropdownDateChange}
                  >
                    <option
                      value="all"
                      selected={selectedDate === 'all' ? 'selected' : ''}
                    >
                      All Days
                    </option>
                    {groupDataList?.calendar.map(dateEvent => (
                      <option
                        key={dateEvent.date}
                        value={dateEvent.date}
                        selected={
                          selectedDate === dateEvent.date ? 'selected' : ''
                        }
                      >
                        {formatDate(dateEvent.date)}
                      </option>
                    ))}
                  </select>
                  <i className={s.arrowIcon} />
                </div>
                <div className={s.timeZone}>
                  <select
                    value={timeFormat}
                    onChange={handleTimeFormatChange}
                    aria-label="Toggle Time Format"
                  >
                    <option value="IST">India Time</option>
                    <option value="GMT">Paris Time</option>
                  </select>
                  <i className={s.arrowIcon} />
                </div>
              </div>

              <div>
                {scheduleDataList &&
                  scheduleDataList.map(dateEvent => {
                    const groupedEvents1 = groupBySport(dateEvent.events);
                    return (
                      <div key={dateEvent.date}>
                        {selectedDate === 'all' ? (
                          <div className={s.dateTitle}>
                            <h2>
                              {formatDateevent(dateEvent.date)}{' '}
                              <span>Schedule</span>
                            </h2>
                          </div>
                        ) : (
                          ''
                        )}
                        <ul className={s.eventList}>
                          {Object.keys(groupedEvents1).map((sport, index) => (
                            <li key={index}>
                              <div className={s.eventCard}>
                                <div className={s.eventHeading}>
                                  <h2>{sport}</h2>
                                  {groupedEvents1[sport].filter(
                                    medalevent => medalevent?.is_medal_event,
                                  ).length > 0 && (
                                    <div className={s.medalEvent}>
                                      <i className={s.medalIcon} />
                                      : Medal Event
                                    </div>
                                  )}
                                </div>
                                <div className={s.eventDetail}>
                                  {groupedEvents1[sport].map(
                                    (event, eventIndex) => (
                                      <ScheduleCard
                                        key={eventIndex}
                                        event={event}
                                      />
                                    ),
                                  )}
                                </div>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    );
                  })}
              </div>
            </>
          )}
      </div>
    </>
  );
};

PointsTableWrapperV2.propTypes = {
  sectionItem: PropTypes.objectOf({}),
};
PointsTableWrapperV2.defaultProps = {
  sectionItem: {},
};

export default React.memo(PointsTableWrapperV2);
